import type { SVGProps } from 'react'

const SvgRedo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M10.4997 7.00008L12.833 7.00008L9.91634 9.91675L6.99967 7.00008L9.33301 7.00008C9.33301 6.07182 8.96426 5.18158 8.30788 4.52521C7.6515 3.86883 6.76127 3.50008 5.83301 3.50008C4.90475 3.50008 4.01451 3.86883 3.35813 4.52521C2.70176 5.18158 2.33301 6.07182 2.33301 7.00008C2.33301 7.92834 2.70176 8.81858 3.35813 9.47496C4.01451 10.1313 4.90475 10.5001 5.83301 10.5001V11.6667C4.59533 11.6667 3.40835 11.1751 2.53318 10.2999C1.65801 9.42474 1.16634 8.23776 1.16634 7.00008C1.16634 5.7624 1.65801 4.57542 2.53318 3.70025C3.40835 2.82508 4.59533 2.33342 5.83301 2.33342C7.07068 2.33342 8.25767 2.82508 9.13284 3.70025C10.008 4.57542 10.4997 5.7624 10.4997 7.00008Z"
        fill="#5E5E5E"
      />
    </svg>
  )
}

export default SvgRedo
